import React from 'react';
import { string, node } from 'prop-types';
import { TransitionGroup } from 'react-transition-group';
import FadeTransition from '../FadeTransition/FadeTransition';

export default function SwitchFadeTransition({ keyIn, children, className }) {
    return (
        <TransitionGroup className={className}>
            <FadeTransition
                key={keyIn}
                addEndListener={(AnimNode, done) =>
                    AnimNode.addEventListener('transitionend', done, false)
                }
            >
                {children}
            </FadeTransition>
        </TransitionGroup>
    );
}

SwitchFadeTransition.propTypes = {
    keyIn: string.isRequired,
    className: string,
    children: node.isRequired,
};

SwitchFadeTransition.defaultProps = {
    className: null,
};
